import { fetcher, FetcherError } from '@bino/utils/fetcher';
import type { AddToCartRequest, Arrangement } from './types';

type SignIn = {
    bannerId?: string;
};

export const JUST_SIGNED_IN_KEY = 'justSignedIn';
export const GO_TO_APPLICATION_URL = '/api/cart/go-to-application';

export const getSignInUrl = ({ bannerId = undefined }: SignIn = {}): string => {
    const url = new URL(window.location.href);
    if (bannerId) {
        url.searchParams.set('a', bannerId);
    }
    sessionStorage.setItem(JUST_SIGNED_IN_KEY, 'true');

    const redirectUrl = encodeURIComponent(url.toString());
    return `/api/cart/sign-in?redirectUrl=${redirectUrl}`;
};

export async function addToCart(arrangements: Arrangement[]): Promise<void> {
    const bannerId = arrangements[0].bannerId;
    const body: AddToCartRequest = {
        arrangementBannerId: bannerId,
    };

    try {
        return await fetcher.post('/api/cart', body);
    } catch (error: unknown) {
        if (error instanceof FetcherError && error.status === 410) {
            const url = new URL(window.location.href);
            url.searchParams.set('a', bannerId);
            const redirectUrl = encodeURIComponent(url.toString());
            window.location.href = `/api/cart/ensure-logged-in?redirectUrl=${redirectUrl}`;
            return;
        }
        throw error;
    }
}

export async function deleteCartItem(bannerId: string): Promise<void> {
    try {
        return await fetcher.delete(`/api/cart/item/${bannerId}`);
    } catch (error: unknown) {
        if (error instanceof FetcherError && error.status === 410) {
            const url = new URL(window.location.href);
            const redirectUrl = encodeURIComponent(url.toString());
            window.location.href = `/api/cart/ensure-logged-in?redirectUrl=${redirectUrl}`;
            return;
        }
        throw error;
    }
}
